import { Controller } from '@hotwired/stimulus'

export default class PurchaseCheckoutController extends Controller {
  static targets = [
    'acceptOverpriceCheckbox',
    'submitButton',
  ];

  static values = {
    overpriced: Boolean,
    missingAmount: Number,
  };

  connect() {
    this.#updateButton();
  }

  onCheckboxChange() {
    this.#updateButton();
  }

  prefillPayinModal() {
    if (this.missingAmountValue <= 0 || this.missingAmountValue > 500) return;

    var modalElement = document.getElementById('payinModal');
    if (modalElement) {
      modalElement.dataset.prefillAmount = this.missingAmountValue;
    }
  }

  #updateButton() {
    if (!this.hasSubmitButtonTarget) return;

    this.submitButtonTarget.disabled = !this.#allChecked();
  }

  #allChecked() {
    if (this.overpricedValue && this.hasAcceptOverpriceCheckboxTarget) {
      return this.acceptOverpriceCheckboxTarget.checked;
    }

    return true;
  }
}
